import { type ReactNode, useState } from "react"
import styled, { css } from "styled-components"

import Button from "~/themes/school/components/Button"
import { fonts, lightTextColor } from "~/themes/school/styles"

interface TabsProps {
	tabs: {
		title: string
		content: ReactNode
		icon?: ReactNode
	}[]
	selectedTabIndex: number
	setSelectedTabIndex: (value: number) => void
	className?: string
}

interface ControlledTabsProps {
	tabs: {
		title: string
		content: ReactNode
	}[]
	className?: string
}

const Tabs: React.FC<TabsProps> = ({ selectedTabIndex, setSelectedTabIndex, tabs, className }) => (
	<div className={className}>
		<TabBar>
			{tabs.map(({ title }, index) => (
				<Tab key={index} isActive={selectedTabIndex === index} onClick={() => setSelectedTabIndex(index)}>
					{title}
				</Tab>
			))}
		</TabBar>
		{tabs.map(({ content }, index) => (
			<TabContent key={index} $isActive={selectedTabIndex === index}>
				{content}
			</TabContent>
		))}
	</div>
)

export const ControlledTabs: React.FC<ControlledTabsProps> = props => {
	const [selectedTabIndex, setSelectedTabIndex] = useState(0)

	return <Tabs selectedTabIndex={selectedTabIndex} setSelectedTabIndex={setSelectedTabIndex} {...props} />
}

const TabBar = styled.div`
	width: 100%;
	display: flex;
	gap: 22px;
	overflow-x: auto;
`

const Tab = styled(Button)<{ isActive: boolean }>`
	font-family: ${fonts.quicksand};
	font-size: 14px;
	font-weight: bold;
	color: ${props => (props.isActive ? props.theme.primaryColor : lightTextColor)};
	white-space: nowrap;
`

const TabContent = styled.div<{ $isActive: boolean }>`
	padding-top: 16px;

	${props =>
		!props.$isActive &&
		css`
			display: none;
		`}
`
